import React from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginScreen from './Screens/LoginScreen';
import MainScreen from './Screens/MainScreen';
import AddOrderScreen from './Screens/AddOrderScreen';
import EditOrderScreen from './Screens/EditOrderScreen';
import RegisterScreen from './Screens/RegisterScreen';
import { AuthProvider } from './Components/AuthContext';
import ProtectedRoute from './Components/ProtectedRoute';
function App() {
  const basename = process.env.PUBLIC_URL || ''; // Usa la clave "homepage" de package.json
  return (
    <AuthProvider>
      <Router basename={basename}>
        <Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/register" element={<RegisterScreen />} />
          <Route path="/main" element={<ProtectedRoute><MainScreen /></ProtectedRoute>} />
          <Route path="/add-order" element={<ProtectedRoute><AddOrderScreen /></ProtectedRoute>} />
          <Route path="/edit-order/:orderId" element={<ProtectedRoute><EditOrderScreen /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
